export const ASSETS = {
  logo: `${process.env.PUBLIC_URL}/logo-sleiman.png?v=3`,
  insignia: "https://customer-assets-4nw71qhi.emergentagent.net/job_ali-sleiman-rcic/artifacts/09ndhs6l_INSIGNIA.webp",
  portrait: "https://customer-assets-4nw71qhi.emergentagent.net/job_ali-sleiman-rcic/artifacts/ptqulxb1_ali%20sleiman.jpg",
};

export const IMAGES = {
  ottawaSkyline: "https://images.unsplash.com/photo-1782751935265-3a6ef9f6c266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxPdHRhd2ElMjBza3lsaW5lJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NTg0MTU2NXww&ixlib=rb-4.1.0&q=85",
  parliament: "https://images.unsplash.com/photo-1760416284277-d6f1c4dad180?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxDYW5hZGlhbiUyMFBhcmxpYW1lbnQlMjBIaWxsfGVufDB8fHx8MTc4NTg0MTU2Nnww&ixlib=rb-4.1.0&q=85",
  architecture: "https://images.pexels.com/photos/9458996/pexels-photo-9458996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  passport: "https://images.unsplash.com/photo-1454496406107-dc34337da8d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxwYXNzcG9ydCUyMGJvYXJkaW5nJTIwcGFzcyUyMHRyYXZlbHxlbnwwfHx8fDE3ODU4NDE1NjZ8MA&ixlib=rb-4.1.0&q=85",
  rings: "https://images.unsplash.com/photo-1637616919953-5943e10bd4bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwcmluZ3MlMjBtaW5pbWFsfGVufDB8fHx8MTc4NTg0MTU2Nnww&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/photo-1779912608267-b82cbaa72fb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZXNpZGVudGlhbCUyMG5laWdoYm9yaG9vZCUyMHN0cmVldHxlbnwwfHx8fDE3ODU4NDE1NjZ8MA&ixlib=rb-4.1.0&q=85",
  airport: "https://images.unsplash.com/photo-1655919640606-28088c64edb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhaXJwb3J0JTIwdGVybWluYWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg1ODQxNTY1fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    num: "01",
    title: "Express Entry — Skilled Workers",
    desc: "Professional guidance for skilled workers seeking permanent residence through Canada's Express Entry system.",
    image: IMAGES.airport,
  },
  {
    num: "02",
    title: "Spousal Sponsorship",
    desc: "Helping reunite spouses and partners with their loved ones in Canada.",
    image: IMAGES.rings,
  },
  {
    num: "03",
    title: "Family Sponsorship",
    desc: "Supporting Canadian citizens and permanent residents in sponsoring eligible family members.",
    image: IMAGES.residential,
  },
  {
    num: "04",
    title: "Visitor Visas",
    desc: "Professional assistance with visitor visa applications.",
    image: IMAGES.passport,
  },
];

export const FAQS = [
  {
    q: "What is a Regulated Canadian Immigration Consultant (RCIC)?",
    a: "An RCIC is a professional authorized by the College of Immigration and Citizenship Consultants (CICC) to lawfully represent and advise clients on Canadian immigration matters. Ali Sleiman is a member in good standing with the CICC.",
  },
  {
    q: "How much experience does Ali Sleiman have?",
    a: "Over 30 years navigating Canada's evolving immigration landscape. We didn't just learn the rules yesterday — we have watched Canada's immigration system evolve since the 1990s.",
  },
  {
    q: "Which immigration programs do you assist with?",
    a: "We provide guidance on Express Entry for skilled workers, spousal sponsorship, family sponsorship, and visitor visa applications, among other pathways.",
  },
  {
    q: "Where are you located?",
    a: "We are based in Canada's national capital, Ottawa, and assist individuals, families, and professionals looking to build their future in Canada.",
  },
  {
    q: "How do I get started?",
    a: "Simply reach out through our contact form or book a consultation. We will review your situation and provide professional, clear, and personalized guidance.",
  },
];

export const CONTACT = {
  whatsapp: "+1 (343) 575-4900",
  whatsappHref: "https://wa.me/13435754900",
  email: "info@sleiman.ca",
  cicc: "https://college-ic.ca/protecting-the-public/find-an-immigration-consultant",
  location: "Ottawa, Ontario — Canada",
};
